import React, { Component } from 'react';
import style from './public.link.layout.less';
import LeftBar from '../leftbar/leftbar.jsx';
import iconsStyle from '../../styles/icons.less';
import className from 'classnames';
import i18n from './../../i18n.jsx';
const _ = i18n;
import { validateEmail } from '../../../common/utils.jsx';
import { KEY_CODES } from '../../../common/utils.jsx';

/*

* */

const welcomeText = _(`Welcome to the Invitae Family Health History Questionnaire, a digital tool used by your healthcare provider to capture your family health history and assess your risk of certain genetic diseases in order to determine whether you are a candidate for genetic testing.`);
const privacyText = _(`The privacy and security of Protected Health Information is our primary concern. All information entered into the Family History Tool is stored in an encrypted HIPAA-compliant server. We do NOT use the information you provide unless your healthcare provider orders a test through the tool (at which point we need the family history information to aid in the interpretation of test results). We do not use your family history information for research purposes, nor do we allow third parties to have access to this information.`);
const informationText = _(`Your use of the Invitae Family History Tool is subject to our <a href=\"https://www.invitae.com/en/terms/\" target=\"_blank\">Terms of Use</a>.`);
const emailPlaceholder = _('e.g. name@mailbox.com');
const { ENTER, SPACE } = KEY_CODES;

export class Popover extends Component {
    constructor() {
        super();
        this.hidePopover = this.hidePopover.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.state = { open: true };
    }
    hidePopover() { this.setState({ open: false }); }
    keyDownHandler(event) {
        const keyCode = event.keyCode;
        if ((ENTER === keyCode) || (SPACE === keyCode)) {
            this.hidePopover();
            event.preventDefault();
        }
    }
    render() {
        const headerLink = this.props.headerLink;
        const open = this.state.open;
        return open ? (
            <div className={style.popoverWrapper}>
                <div className={style.popover}>
                    <div>
                        <a className={style.popoverHeaderIcon} href={headerLink}></a>
                        <p className={style.popoverHeaderText}>{_('family history tool')}</p>
                    </div>
                    <p>{welcomeText}</p>
                    <p>{privacyText}</p>
                    <p><span dangerouslySetInnerHTML={{ __html: informationText }}></span></p>
                    <div onKeyDown={this.keyDownHandler} onClick={this.hidePopover} tabIndex="0" className={style.popoverCloseBtn}>{_('Close')}</div>
                </div>
            </div>
        ) : null;
    }
}

export class Avatar extends Component {
    render() {
        return (
            <div className={style.avatarIconWrapper}>
                <span className={style.avatarIcon}></span>
            </div>
        );
    }
}

export class Form extends Component {
    constructor() {
        super();
        this.submitForm = this.submitForm.bind(this);
        this.state = { error: false };
    }
    submitForm(event) {
        let error;
        const email = this.refs.email.value;
        const isValidEmail = validateEmail(email);
        if (!isValidEmail) {
            error = email ? _('Invalid email.') : _('Cannot be empty.');
            this.setState({ error });
            event.preventDefault();
        }
    }
    render() {
        const csrf = this.props.csrf;
        const submitBtnIconStyle = className(style.submitBtnIcon, iconsStyle[`icon-round-start`]);
        const error = this.state.error;
        return (
            <div className={style.form}>
                <div className={style.textWrapper}>
                    <div className={style.formText}>
                        <p>{_('Hi')},</p>
                        <p>{_('This questionnaire will ask about your personal and family medical histories, specifically focusing on cancer.')}</p>
                        <p>{_(`By answering these questions now, you'll have more time to talk to your healthcare provider at your next visit. The questionnaire should take about 30 minutes.`)}</p>
                        <p>{_(`Don't worry if you don't know the answer to a question - just move on to the next one.`)}</p>
                        <p>{_(`Thank you for your time.`)}</p>
                    </div>
                    <div className={style.formGroup}>
                        <label htmlFor="id_email">{_('Please enter your e-mail to start')} *</label>
                        { error
                            ? <ul className={style.error}><li>{error}</li></ul>
                            : null
                        }
                        <input type="hidden" name="csrfmiddlewaretoken" value={csrf}/>
                        <input type="text" name="email" ref="email" placeholder={emailPlaceholder}/>
                    </div>
                </div>
                <div className={style.formActions} onClick={this.submitForm}>
                    <button type="submit" className={style.submitButton}>
                        <span className={submitBtnIconStyle}></span>
                        {_('Start')}
                    </button>
                </div>
            </div>
        );
    }
}

export class PublicLinkForm extends Component {
    render() {
        const csrf = this.props.csrf;
        return (
            <div className={style.container}>
                <div className={style.formWrapper}>
                    <form method="post">
                        <section className={style.section}>
                            <Avatar />
                            <Form csrf={csrf} />
                        </section>
                    </form>
                </div>
            </div>
        );
    }
}

export default class PublicLinkLayout extends Component {
    render() {
        const { headerLink, navigationPageList, staticLeftBar } = this.props;
        const props = { headerLink, navigationPageList, staticLeftBar };
        const csrf = this.props.csrf[0].value;
        return (
            <div>
                <LeftBar {...props}/>
                <PublicLinkForm csrf={csrf}/>
                <Popover headerLink={headerLink} />
            </div>
        );
    }
}
